<script>
/**
 * @component ValidationLayout
 * @description Layout del módulo de Validaciones con navegación por tabs.
 * Tabs: Validar | Historial
 * Mismo patrón visual que Agenda.
 */
export default {
  name: "ValidationLayout",
  computed: {
    /** @returns {string} Nombre de la ruta activa */
    activeTab() {
      return this.$route.name;
    },
  },
  methods: {
    /**
     * @method goTo
     * @param {string} name - Nombre de la ruta
     */
    goTo(name) {
      if (this.$route.name !== name) this.$router.push({ name });
    },
  },
};
</script>

<template lang="pug">
  div
    .validation-tabs
      button.validation-tab(
        :class="{ 'validation-tab--active': activeTab === 'validation' }"
        @click="goTo('validation')"
      ) Validar
      button.validation-tab(
        :class="{ 'validation-tab--active': activeTab === 'validation-authorization' }"
        @click="goTo('validation-authorization')"
      ) Con autorización
      button.validation-tab(
        :class="{ 'validation-tab--active': activeTab === 'validation-history' }"
        @click="goTo('validation-history')"
      ) Historial
    router-view
</template>

<style lang="scss" scoped>
.validation-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 0;
}

.validation-tab {
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  padding: 12px 20px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: #002d5e;
  }

  &--active {
    color: #002d5e;
    font-weight: 700;
    border-bottom-color: #002d5e;
  }
}
</style>
